import React from 'react';

import {hooks} from '../hooks';
import {PartnersType} from '../types';
  
type Props = {
  index: number;
  partner: PartnersType;
  isLast: boolean;
};

export const PartnersItem: React.FC<Props> = ({index, partner, isLast}) => {
  const navigate = hooks.useNavigate();

  return (
    <li
      style={{
        borderRadius: 10,
        position: 'relative',
        backgroundColor: 'var(--white-color)',
        display: 'block',
        height: 207,
        maxHeight: "100%",
      }}
      onClick={() => navigate(`/detail-partners/${partner.id}`, {state: {partner}})}
    >
      <img
        src={partner.img}
        alt={partner.title}
        style={{objectFit: 'cover', width: '100%', height: 100, borderRadius: 6}}
      />
      <div style={{display: 'flex', gap: 5, flexDirection: 'column', padding: 14}}>
          <h5 className='number-of-lines-1'>{partner.title}</h5>
          <p className='t12 number-of-lines-2' style={{marginBottom: 10, overflow: 'hidden'}}>{partner.description}</p>
      </div>
      {/* <components.Name
        son={son.name}
        containerStyle={{marginBottom: 3}}
      /> */}
      <div style={{width: '100%'}}>
      </div>
    </li>
  );
};
